import React, { useState } from "react";
import "../Assets/Styles/Modals/GetInTouchModal.css";
import { MdClose } from "react-icons/md";
import { IMAGES } from "../utils";

const GetInTouchModal = ({ inTouchShow, setInTouchShow }) => {
  const [inTouchState, setInTouchState] = useState({
    ContactID: 0,
    FullName: "",
    Email: "",
    Mobile: "",
    Subject: "",
    CreatedBy: 1,
    errors: [],
  });
  const handleGetInTouchChange = (e) => {
    setInTouchState({
      ...inTouchState,
      [e.target.name]: e.target.value,
      errors: { ...inTouchState.errors, [e.target.name]: "" },
    });
  };
  const clearStates = () => {
    setInTouchState({
      ContactID: 0,
      FullName: "",
      Email: "",
      Mobile: "",
      Education: "",
      Subject: "",
      CreatedBy: 1,
      errors: "",
    });
  };
  const getHandleClose = () => {
    setInTouchShow(false);
    clearStates();
  };
  const validateGetInTouch = () => {
    const errors = {};
    let IsValid = true;
    const regex_name = /^[A-Za-z\s]+$/;
    const regex_email = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
    const Mobilenumber = /^[7-9][0-9]/;

    if (!inTouchState.FullName) {
      IsValid = false;
      errors["FullName"] = "Full Name Is Required";
    } else if (inTouchState.FullName.length < 2) {
      IsValid = false;
      errors["FullName"] = "Must Be 15 Characters ";
    } else if (!inTouchState.FullName.match(regex_name)) {
      IsValid = false;
      errors["FullName"] = "Please Enter Valid Name";
    } else {
      errors["FullName"] = "";
    }

    if (!inTouchState.Mobile) {
      IsValid = false;
      errors["Mobile"] = "Mobile number Is Required";
    } else if (
      inTouchState.Mobile.length < 10 ||
      inTouchState.Mobile.length > 10
    ) {
      IsValid = false;
      errors["Mobile"] = "Mobile Number Must Have 10 Digits";
    } else if (!inTouchState.Mobile.match(Mobilenumber)) {
      IsValid = false;
      errors["Mobile"] = "Please Enter valid Mobile Number";
    } else {
      errors["Mobile"] = "";
    }

    if (!inTouchState.Email) {
      IsValid = false;
      errors["Email"] = "Email ID Is Required";
    } else if (!inTouchState.Email.match(regex_email)) {
      IsValid = false;
      errors["Email"] = "Please Enter valid Email id";
    } else {
      errors["Email"] = "";
    }

    if (!inTouchState.Subject) {
      IsValid = false;
      errors["Subject"] = "Subject  Is Required";
    } else {
      errors["Subject"] = "";
    }
    setInTouchState({
      ...inTouchState,
      errors: errors,
    });
    return IsValid;
  };
  const handleGetInTouchSubmit = () => {
    if (validateGetInTouch()) {
      console.log("submit-->", inTouchState);
      clearStates();
      setInTouchShow(false);
    }
    alert("please Enter ProPer Details");
  };
  return (
    <>
      <div
        className="modal fade get-in-touch-modal"
        id="staticBackdropTouch"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
        onHide={getHandleClose}
      >
        <div className="modal-dialog get-in-touch-modal-dialog">
          <div className="modal-content">
            <button
              type="button"
              className="get-in-touch-btn-close "
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={getHandleClose}
            >
              <MdClose size={25} className="get-in-touch-btn-close-icon" />
            </button>

            <div className="modal-body get-in-touch-modal-body">
              <div className="row ">
                <div className="col-lg-7">
                  <div className="get-in-touch-section">
                    <h5
                      className="modal-title get-career-guidance-modal-title"
                      id="staticBackdropLabel"
                    >
                      Get In Touch
                    </h5>
                    <p className="get-career-guidance-modal-text">
                      We can be reached via phone or email around the clock. Use
                      our contact form as well.
                    </p>
                    <div className="w-100 mb-3 px-2">
                      {/* <label className="mb-1">Full Name</label> */}
                      <input
                        type="text"
                        className="reg-form-control"
                        placeholder="Full Name"
                        autoComplete="off"
                        name="FullName"
                        value={inTouchState.FullName}
                        onChange={handleGetInTouchChange}
                      />
                      {inTouchState.errors ? (
                        <p className="req-errors">
                          {inTouchState.errors.FullName}
                        </p>
                      ) : null}
                    </div>

                    <div className="w-100 mb-3 px-2">
                      {/* <label className="mb-1">Mobile Number</label> */}
                      <input
                        type="number"
                        className="reg-form-control"
                        placeholder="Mobile Number"
                        autoComplete="off"
                        name="Mobile"
                        value={inTouchState.Mobile}
                        onChange={handleGetInTouchChange}
                      />
                      {inTouchState.errors ? (
                        <p className="req-errors">
                          {inTouchState.errors.Mobile}
                        </p>
                      ) : null}
                    </div>

                    <div className="w-100 mb-3 px-2">
                      {/* <label className="mb-1">Email ID</label> */}
                      <input
                        type="email"
                        className="reg-form-control"
                        placeholder="Email ID"
                        autoComplete="off"
                        name="Email"
                        value={inTouchState.Email}
                        onChange={handleGetInTouchChange}
                      />
                      {inTouchState.errors ? (
                        <p className="req-errors">
                          {inTouchState.errors.Email}
                        </p>
                      ) : null}
                    </div>

                    <div className="w-100 mb-3 px-2">
                      {/* <label className="mb-1">Subject</label> */}
                      <textarea
                        className="reg-form-control"
                        placeholder="Subject"
                        rows={2}
                        autoComplete="off"
                        name="Subject"
                        value={inTouchState.Subject}
                        onChange={handleGetInTouchChange}
                      ></textarea>
                    </div>
                    <div className="w-100 px-2 get-in-touch-btn-wrapper">
                      <div className="blue-green-btn">
                        <button onClick={handleGetInTouchSubmit}>
                          <span className="btn-text">Get In Touch</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="get-in-touch-img-wrapper">
                    <div></div>
                    <img src={IMAGES.GetInTouch} alt=""  className="animate__animated animate__slideInRight" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GetInTouchModal;
